import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {Checkbox, ListItemButton, ListItemIcon} from "@mui/material";
import {useEffect} from "react";

export const Courses = ({items, onChange, courses}) => {
    const [checked, setChecked] = React.useState(courses || items.map(item => item.id));

    useEffect(()=>{
        onChange(checked);
    }, [])

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        onChange(newChecked);
        setChecked(newChecked);
    };

    return (
        <List>
            {items.map(({text, id, disabled}) => (
                <ListItem  key={id} disablePadding={true}>
                    <ListItemButton sx={{padding: 0}} disabled={checked.includes(id) && checked.length===1}  onClick={handleToggle(id)}>
                        <ListItemIcon>
                            <Checkbox checked={checked.includes(id)} tabIndex={-1} disableRipple/>
                        </ListItemIcon>
                        <ListItemText id={id} primary={text}/>
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    );
}
